import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorModule } from '../form-error/form-error.module';
import { InputModule } from '../input/input.module';
import { MonthRangeComponent } from './month-range.component';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [MonthRangeComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorModule, InputModule, DatePickerModule],
  exports: [MonthRangeComponent],
})
export class MonthRangeModule {}
